<template>
<div data-component="Rating.vue" class="rating | flex flex-grow-0 items-center">
	<div v-if="DisplayText && Count" class="text-accent text-base font-extrabold mr-2" v-html="Average"/>
	<template v-if="(Math.ceil(Value/2))">
		<OIcon v-for="i in (Math.ceil(Value/2))" :key="i" class="text-accent mr-1" name="star-on" :size="Size" :data-test="dataTest ? `${dataTest}__star` : undefined"/>
	</template>
	<template v-if="(5 - Math.ceil(Value/2))">
		<OIcon v-for="i in (5 - Math.ceil(Value/2))" :key="i" class="text-neutral-600 opacity-50 mr-1" name="star-on" :size="Size" :data-test="dataTest ? `${dataTest}__star` : undefined"/>
	</template>
	<div v-if="DisplayText" class="text-neutral-600 mx-2" :data-test="dataTest ? `${dataTest}__label` : undefined" v-html="`(${Count} ${Format.PluralForm(Count, ['opinia', 'opinie', 'opinii'])})`"/>
</div>
</template>

<script lang="ts">
// @vuese
// Komponent odpowiedzialny za wyświetlenie oceny w postaci gwiazdek.
// @group Base Components
export default {
	name: 'Rating',
	props: {
		Size: {
			type: Number,
			default: 1.25,
		},
		Value: {
			type: Number,
			default: 5,
		},
		Count: {
			type: Number,
			default: 0,
		},
		Average: {
			type: [Number, String],
			default: 0,
		},
		DisplayText: {
			type: Boolean,
			default: false,
		},
		dataTest: {
			type: String,
			default: undefined,
		},
	},
};
</script>

<style lang="scss" scoped>
	.rating {

	}

	.rate-refund .i {
		fill: #666 !important;
	}

</style>
